import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme, AppStyles } from '../styles/AppTheme';
import { Grid, FormControl, InputLabel, Select, Input, MenuItem, Button } from '@material-ui/core';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { AppButton } from '../common/components/AppButton';

export class FilterBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      month: this.props.month,
      year: this.props.year
    }
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <form key='form' autoComplete='off' className={css(Styles.form)}>
          <div>
            <Grid container  className={css(Styles.filterBarGrid)}>
              <Grid item xs={4} sm={3} >
                <FormControl className={css(Styles.formControl)} fullWidth>
                  <Select
                    name='month'
                    value={this.state.month}
                    onChange={e => this.change(e)}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                      },
                      getContentAnchorEl: null,
                      className: css(Styles.menuProps, Styles.inputStyle),
                      classes: {
                        paper: css(Styles.paperSelect)
                      }
                    }}
                    input={<Input name='month' label='Month' disableUnderline={true} />}
                    inputProps={{
                      classes: {
                        root: css(Styles.textInputStylesDialog)
                      }
                    }}
                    className={css(Styles.formControlDialog)}
                  >
                    {this.props.data.months.map(item => {
                      return (
                        <MenuItem
                          value={item.key}
                          key={item.key}
                          className={css(Styles.menuItemContainer)}>
                          <p className={css(Styles.margin)}>{item.label}</p>
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>


              </Grid>
              <Grid item xs={4} sm={3} >
                <FormControl variant='outlined' fullWidth >
                  <Select
                    name='year'
                    value={this.state.year}
                    onChange={e => this.change(e)}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                      },
                      getContentAnchorEl: null,
                      className: css(Styles.menuProps, Styles.inputStyle),
                      classes: {
                        paper: css(Styles.paperSelect)
                      }
                    }}
                    input={<Input name='year' label='Year' disableUnderline={true} />}
                    inputProps={{
                      classes: {
                        root: css(Styles.textInputStylesDialog)
                      }
                    }}
                    className={css(Styles.formControlDialog)}
                  >
                    {this.props.data.years.map(item => {
                      return (
                        <MenuItem
                          value={item.key}
                          key={item.key}
                          className={css(Styles.menuItemContainer)}>
                          <p className={css(Styles.margin)}>{item.label}</p>
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={4} sm={2}>
                <AppButton
                  buttonStyle={Styles.button}
                  onClick={this.onFilter.bind(this)}
                  buttonText={this.props.buttonLabel || 'Filter'}
                />
              </Grid>
            </Grid>
          </div>
        </form>
      </div>
    )
  }

  change = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  onFilter() {
    if (this.state.month && this.state.year) {
      this.props.onFilter(this.state.year, this.state.month)
    }
  }
}


const Styles = StyleSheet.create({
  filterBarGrid:{
    gap: 20,
    marginTop:10,
    '@media (max-width: 1024px)': {
      gap: 6,
      flexWrap: 'nowrap'
    }
  },
  container: {
    // top: AppTheme.toolbarHeight,
    // minHeight: AppTheme.toolbarHeight * 2 / 3,
    display: 'flex',
    justifyContent: 'center',
    // backgroundColor: 'white',
    width: '100%',
    marginBottom: 16,
    marginTop: 16,
    maxWidth: AppTheme.viewPort,
  },
  searchInput: {
    minWidth: 150,
    paddingTop: 2,
    paddingBottom: 2
  },
  button: {
    // color: AppTheme.buttonTextColor,
    // boxShadow: 'none',
    '@media (max-width: 767px)': {
      width: '100%',
    }
    // marginTop: 10,
    // marginLeft : 10,
    //minWidth: 150
  },
  // emailSearchButton: {
  //   marginTop: 16,
  // },
  form: {
    display: 'flex',
    flexDirection: 'column',
    // flex: 1,
    // padding: AppTheme.pagePadding,
    '@media (max-width: 320px)': {
      maxWidth: 300,
      paddingBottom: 15,
    },
    maxWidth: AppTheme.viewPort,
    // backgroundColor: 'white',
    // paddingTop: 0,
    // paddingBottom: 6,
    // paddingLeft: 16,
    // paddingRight: 16,
    width: '100%',
    borderRadius: 8
  },
  leftGridPadding: {
    paddingRight: 10,
    '@media (max-width: 767px)': {
      paddingRight: 0,
    }
  },
  rightGridPadding: {
    display: 'flex',
    alignItems: 'flex-end',
    paddingBottom: 10,
    '@media (max-width: 767px)': {
      paddingBottom: 0,
    }
  },


  labelContainer: {
    fontWeight: 'bold'
  },
  menuItemListContainerRoot: {
    padding: 0
  },
  selectMenu: {
    backgroundColor: AppTheme.secondaryBg,
    color: 'black',
  },
  selectIcon: {
    color: '#A4A4A4',
  },
  margin: {
    margin: 0,
    textAlign: 'left'
  },
  formControlDialog:{
    borderRadius: 8,
    border: 'none',
    background: '#FFF',
    overflow: 'hidden'
  },
  textInput: {
    padding: '4px 0px'
  },
  textInputStylesDialog:{
    padding: '14px 16px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16,
    ':focus': {
      backgroundColor: '#ffffff'
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/FilterBar.js